import * as React from 'react'
import { Route, Switch } from 'react-router-dom'

import * as common from '@rushplay/common'
import { lazy as loadable } from '@loadable/component'

import { Divider } from './divider'

const CasinoCategory = loadable(() => import('./casino-category'))
const CasinoNavigation = loadable(() => import('./casino-navigation'))
const SearchPage = loadable(() => import('./search-page'))

export function Casino() {
  return (
    <common.Box overflow="hidden" flexGrow="1" pt={[1, 2]} pb={[5, 2]}>
      <common.Box pb={[1, 2]}>
        <Route path="/casino" component={CasinoNavigation} />
        <common.Space pt={0} px={[1, 2]}>
          <Divider />
        </common.Space>
      </common.Box>
      <Switch>
        <Route path="/casino/search" component={SearchPage} />
        <Route path="/casino/:id/:slug" component={CasinoCategory} />
      </Switch>
    </common.Box>
  )
}

// for @loadable/components
export default Casino
